import { ItemList, List } from './listDocStyle'
import { icons } from '../../constants/images'
import { IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import React from 'react';
import FolderApi from '../../api/folder/folder.api';
import { swalActive, swalError, swalSuccess } from '../notification/swal';
import { saveAs } from 'file-saver';

import FileApi from '../../api/file/file.api';
import InputCheckbox from '../input/inputCheckbox';
const options = [
    'ดูเอกสาร',
    'ดาวน์โหลด',
    'ทำซ้ำ',
    'การเข้าถึง',
];
type MenuProps = {
    type?: string
    icon: any;
    onClick?: () => void
    dropDown?: boolean
    style?: any
    loadDataLevel?: any
    setLevel?: any
    file?: any
    loadData?: any
    handleClickOpenCreate?: any
    detail?: any
    setInputFolder?: any
    inputFolder?: any
    setLevelFiles?: any
    checkbox?: boolean
    levelfiles?: any
    stepView?: number
    layer?: number
    step?: number

}
const ITEM_HEIGHT = 48;
export default function ListDoc(props: MenuProps) {
    const { onClick, step, icon, dropDown, style, type, file, loadData, handleClickOpenCreate, detail, inputFolder, setInputFolder, setLevelFiles, checkbox, levelfiles, stepView, layer } = props
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const deleteFolder = async () => {

        swalActive(
            `ยืนยันที่จะลบหรือไม่?`,
            null, (res: any) => {
                if (res) {
                    FolderApi.patchFolderDelete(detail?.idFolder)
                        .then(async (res) => {
                            console.log(detail,step);
                            swalSuccess('ลบสำเร็จ', '', null, () => {
                                if (inputFolder?.idReferFolder !== detail?.idFolder) {
                                    window.location.reload()

                                } 
                            })
                            setInputFolder({ ...inputFolder, idReferFolder: detail?.idReferFolder, stepView: stepView === inputFolder?.stepView ? inputFolder?.stepView : stepView })

                            loadData()


                        })
                        .catch((error) => {
                            swalError(error.response.data.description || error.response.data.message);

                        })
                }
            })
    }
    const deleteFile = async () => {
        swalActive(
            `ยืนยันที่จะลบหรือไม่?`,
            null, (res: any) => {
                if (res) {
                    FileApi.deleteFile(detail?.idFile)
                        .then(async (res) => {
                            swalSuccess('ลบสำเร็จ')
                            loadData()
                        })
                        .catch((error) => {
                            console.log(error);
                            swalError(error.response.data.description || error.response.data.message);
                        })
                }
            })
    }
    const download = async () => {
        if (type === 'file') {
            const res = await FileApi.getFileDownload(file?.idFile)
            const blob = new Blob([res.data], { type: file?.fileType });
            const url = window.URL.createObjectURL(blob)
            saveAs(url, file?.fileName)
        } else {
            const res = await FolderApi.getFolderDownload(detail?.idFolder)
            const blob = new Blob([res.data], { type: 'application/zip' },);
            const url = window.URL.createObjectURL(blob)
            // window.open(url, '_blank');
            saveAs(url, 'Folder')
        }
    }
    return (
        <Tooltip title={detail?.folderName || detail?.fileName} placement="bottom">

            <List sx={{ ...style }} className='list d-flex justify-content-between align-items-center'>
                {!checkbox && <InputCheckbox checked={detail?.check || false} onChange={(e) => {
                    setLevelFiles([
                        ...levelfiles?.filter((x: any) => !x?.idFile),
                        ...levelfiles?.filter((x: any) => x?.idFile)?.map((x: any) => {
                            x.check = x?.idFile === detail?.idFile ? e.target.checked : x?.check || false
                            return x
                        })
                    ])
                }} />}
                <ItemList className='item-list' onClick={onClick}>
                    <div className='d-flex'>
                        <div style={{ width: '28px', marginRight: '10px' }}>{icon}</div>
                        <Typography sx={{
                            whiteSpace: 'nowrap',
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: "1",
                            overflow: "hidden",
                        }}>
                            {detail?.folderName || detail?.fileName}</Typography>
                    </div>

                </ItemList>
                {!dropDown && <><IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <icons.dotMenuV />
                </IconButton>
                    <Menu
                        id="long-menu"
                        MenuListProps={{
                            'aria-labelledby': 'long-button',
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: '20ch',
                            },
                        }}
                    >


                        <MenuItem
                            onClick={() => {
                                handleClose()
                                download()
                            }}>
                            ดาวน์โหลด
                        </MenuItem>
                        {(detail?.idFile || detail?.level === 5) &&
                            <MenuItem
                                onClick={() => {
                                    handleClose()
                                    deleteFile()
                                }}>
                                ลบไฟล์
                            </MenuItem>}
                        {
                            detail?.permissionLevel !== 1 && type !== 'file' &&
                            <MenuItem
                                onClick={() => {
                                    handleClose()
                                    deleteFolder()
                                }}>
                                ลบ
                            </MenuItem>}
                        {
                            detail?.permissionLevel !== 1 && type !== 'file' && <MenuItem
                                onClick={() => {
                                    setInputFolder({
                                        ...detail,
                                        stepView: stepView,
                                        layer: layer
                                    })
                                    handleClickOpenCreate()
                                    handleClose()
                                }}>
                                แก้ไข
                            </MenuItem>}
                    </Menu>
                </>
                }
            </List >
        </Tooltip>
    )
}
